import * as React from 'react'
function SvgBuilding(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M19.67 4.028a2.03 2.03 0 01.66 0l12 2A2 2 0 0134 8v26a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 011.67-1.972zm.33 4L10 9.694V32h8v-4h4v4h8V9.694L20 8.028zM18 20v4h-4v-4h4zm8 0v4h-4v-4h4zm-8-8v4h-4v-4h4zm8 0v4h-4v-4h4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgBuilding
